__turbopack_context__.v({
  "__animate": "page-module-scss-module__pKZ8oq____animate",
  "card_solution_icon": "page-module-scss-module__pKZ8oq__card_solution_icon",
  "card_solution_item": "page-module-scss-module__pKZ8oq__card_solution_item",
  "card_solution_more": "page-module-scss-module__pKZ8oq__card_solution_more",
  "card_solution_text": "page-module-scss-module__pKZ8oq__card_solution_text",
  "card_solution_title": "page-module-scss-module__pKZ8oq__card_solution_title",
  "description": "page-module-scss-module__pKZ8oq__description",
  "event_banner": "page-module-scss-module__pKZ8oq__event_banner",
  "event_banner_title": "page-module-scss-module__pKZ8oq__event_banner_title",
  "event_content": "page-module-scss-module__pKZ8oq__event_content",
  "event_content_inner": "page-module-scss-module__pKZ8oq__event_content_inner",
  "event_image": "page-module-scss-module__pKZ8oq__event_image",
  "hero_section_inner": "page-module-scss-module__pKZ8oq__hero_section_inner",
  "hero_section_wrapper": "page-module-scss-module__pKZ8oq__hero_section_wrapper",
  "lead_form_inner": "page-module-scss-module__pKZ8oq__lead_form_inner",
  "lead_form_wrap": "page-module-scss-module__pKZ8oq__lead_form_wrap",
  "main_page": "page-module-scss-module__pKZ8oq__main_page",
  "main_title": "page-module-scss-module__pKZ8oq__main_title",
  "main_video": "page-module-scss-module__pKZ8oq__main_video",
  "play_btn": "page-module-scss-module__pKZ8oq__play_btn",
  "product_card_list": "page-module-scss-module__pKZ8oq__product_card_list",
  "product_group": "page-module-scss-module__pKZ8oq__product_group",
  "product_group_label": "page-module-scss-module__pKZ8oq__product_group_label",
  "product_section": "page-module-scss-module__pKZ8oq__product_section",
  "stat_graph": "page-module-scss-module__pKZ8oq__stat_graph",
  "stat_item": "page-module-scss-module__pKZ8oq__stat_item",
  "stat_label": "page-module-scss-module__pKZ8oq__stat_label",
  "stat_left": "page-module-scss-module__pKZ8oq__stat_left",
  "stat_list": "page-module-scss-module__pKZ8oq__stat_list",
  "stat_list_mgb": "page-module-scss-module__pKZ8oq__stat_list_mgb",
  "stat_section": "page-module-scss-module__pKZ8oq__stat_section",
  "stat_section_inner": "page-module-scss-module__pKZ8oq__stat_section_inner",
  "stat_value": "page-module-scss-module__pKZ8oq__stat_value",
  "video_control_wrapper": "page-module-scss-module__pKZ8oq__video_control_wrapper",
  "visual_bg_fadeOut": "page-module-scss-module__pKZ8oq__visual_bg_fadeOut",
  "visual_title_fadeIn": "page-module-scss-module__pKZ8oq__visual_title_fadeIn",
});
